import React from "react";

import {
  Breadcrumb,
  Divider,
  FilterButton,
  Link,
  PageTitle,
  SvgIcon,
  USPBanner,
} from "../../components";

import {
  MainLogo,
  HamburgerSmallIcon,
  HeartWhiteIcon,
  ShoppingBagIcon,
} from "../../icons";

function MobileMenuDefaultFull() {
  return (
    <>
      <USPBanner
        shippingLabel="1–5 working Days"
        returnLabel="FREE Returns & Exchanges"
        pocketLabel="save 2.5% on all purchases"
      />

      <div className="container-fluid header-main">
        <div className="header-center">
          <Link href="/">
            <>
              <SvgIcon
                icon={MainLogo}
                isIcon={false}
                width={155}
                height={16}
                classes={{ root: "header-brand__desktop" }}
              />
              <SvgIcon
                icon={MainLogo}
                isIcon={false}
                width={116}
                height={13}
                classes={{ root: "header-brand__mobile" }}
              />
            </>
          </Link>
          <div className="mobile-menu-header-main-icon-container">
            <SvgIcon icon={HeartWhiteIcon} />
            <SvgIcon icon={ShoppingBagIcon} />
            <SvgIcon icon={HamburgerSmallIcon} />
          </div>
        </div>

        <Divider classes={{ root: "mb-2" }} />
        {/* <Search /> */}
        <Breadcrumb
          backLink={{ text: "Parent Category", href: "/" }}
          mobileBackLink={{ text: "Parent Category", href: "/" }}
        />

        <PageTitle
          title="MENS RUNNING SHOES SECOND LINE"
          productCount={10234}
        />

        <FilterButton title="SORT & FILTER" />

        <Divider classes={{ root: "mt-3" }} />
      </div>
    </>
  );
}

export default MobileMenuDefaultFull;
